var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"value":_vm.formattedValue,"placeholder":_vm.placeholder,"title":_vm.title},on:{"input":_vm.formatValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }